<script lang="ts" setup>
import { PCard, PCardSize, PLayout, PSpace, PSpaceSize, usePrevioDS } from '@previo/design-system'
import PrevioLogo from '~/components/PrevioLogo.vue'

const ds = usePrevioDS()
</script>

<template>
  <p-layout>
    <p-card :pa-mobile="PCardSize.SM" :pa-laptop="PCardSize.XXL" class="p-flex p-full-height">
      <div class="p-full-width p-safe-area-top">
        <p-space :mobile="PSpaceSize.LG" :laptop="PSpaceSize.ZERO" vertical />

        <div v-if="ds.screen().isMobile" class="p-text-center">
          <previo-logo />
        </div>
        <p-space :mobile="PSpaceSize.XXL" vertical />

        <div>
          <router-view />
        </div>
      </div>
    </p-card>
  </p-layout>
</template>
